import React from 'react';
import { ReactDatePickerCustomHeaderProps } from 'react-datepicker';
import { Button, Text } from 'src/@vymo/ui/atoms';
import { format } from 'date-fns';
import { ReactComponent as DoubleLeftIcon } from 'src/assets/icons/arrowDoubleLeft.svg';
import { ReactComponent as DoubleRightIcon } from 'src/assets/icons/arrowDoubleRight.svg';
import { ReactComponent as LeftIcon } from 'src/assets/icons/left.svg';
import { ReactComponent as RightIcon } from 'src/assets/icons/right.svg';
import styles from './index.module.scss';

function CustomDateHeader({
  onClickMonthPicker,
  onClickYearPicker,
  date,
  decreaseMonth,
  increaseMonth,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
  decreaseYear,
  increaseYear,
  prevYearButtonDisabled,
  nextYearButtonDisabled,
}: ReactDatePickerCustomHeaderProps & {
  onClickMonthPicker: () => void;
  onClickYearPicker: () => void;
}) {
  const year = date.getFullYear();
  const monthName = format(date, 'MMMM');

  return (
    <div className={styles.customHeader}>
      <div className={styles.customHeader__nav__left}>
        <Button
          onClick={decreaseYear}
          type="outlined"
          rounded
          disabled={prevYearButtonDisabled}
          isIcon
          size="small"
          className={styles.customHeader__nav__left__button}
          iconProps={{
            icon: <DoubleLeftIcon />,
            iconPosition: 'left',
          }}
        />
        <Button
          onClick={decreaseMonth}
          disabled={prevMonthButtonDisabled}
          type="outlined"
          rounded
          isIcon
          size="small"
          className={styles.customHeader__nav__left__button}
          iconProps={{
            icon: <LeftIcon />,
            iconPosition: 'left',
          }}
        />
      </div>

      <div className={styles.customHeader__content}>
        <Button
          type="primary"
          variant="subtle"
          size="small"
          onClick={onClickMonthPicker}
        >
          {monthName}
        </Button>
        <Text>.</Text>
        <Button
          type="primary"
          variant="subtle"
          size="small"
          onClick={onClickYearPicker}
        >
          {year}
        </Button>
      </div>
      <div className={styles.customHeader__nav__right}>
        <Button
          onClick={increaseMonth}
          disabled={nextMonthButtonDisabled}
          type="outlined"
          rounded
          isIcon
          size="small"
          className={styles.customHeader__nav__right__button}
          iconProps={{
            icon: <RightIcon />,
            iconPosition: 'left',
          }}
        />
        <Button
          onClick={increaseYear}
          disabled={nextYearButtonDisabled}
          type="outlined"
          rounded
          isIcon
          size="small"
          className={styles.customHeader__nav__right__button}
          iconProps={{
            icon: <DoubleRightIcon />,
            iconPosition: 'left',
          }}
        />
      </div>
    </div>
  );
}

export default CustomDateHeader;
